import { BadRequest } from '@tsed/exceptions';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import getIsSsrMobile from '@/lib/getIsSsrMobile';
import { recordConfig } from '@/modules/record/recordConfig';
import RecordPage from '@/modules/record/RecordPage';

type Props = {
  // Declare My Bookings props
  isSsrMobile: boolean;
};

export default function Bookings(
  _props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  const { query, pathname, replace } = useRouter();

  if (query.id) {
    const temp = {
      ...query,
    };
    // delete temp.id;
    replace(
      {
        pathname,
        query: {
          ...temp,
        },
      },
      undefined,
      {
        shallow: true,
      }
    );
  }
  return <RecordPage />;
}

export const getServerSideProps: GetServerSideProps<Props> = async (
  context
) => {
  const { locale } = context;
  if (locale == undefined) {
    throw new BadRequest('locale is missing');
  }

  const { i18nNamespaces } = recordConfig;

  const isSsrMobile = getIsSsrMobile(context);

  return {
    props: {
      ...(await serverSideTranslations(locale, i18nNamespaces)),
      revalidate: 0, // In seconds
      isSsrMobile,
    },
  };
};
